import React, { useState } from 'react'
import CountUp from 'react-countup'
import AnimatedText3 from './AnimatedText3'
import { useInView } from 'react-intersection-observer';
import iconorange from '../images/icon_orange.svg';

const StorySection = () => {
      //counting
      const [startCount, setStartCount] = useState(false);
      const { ref, inView } = useInView({
          triggerOnce: true, // To trigger only once when in view
          threshold: 0.5,    // Adjust threshold as needed (50% of the element is visible)
      });
  
      // When inView becomes true, start the counting
      if (inView && !startCount) {
          setStartCount(true);
      }
  return (
    <div>
           <section id="ourstory">
                <div className="container-xxl story-container">
                    <div className='heading-box'>
                        <div className='text-box' data-aos="fade-up" data-aos-once="true">
                            <img id="iconimgstory" className='icon_orange' src={iconorange} alt='icon-orange' />
                            <p>Our Story</p>
                        </div>

                        <AnimatedText3 />
                    </div>
                    <div className='row mainrow'>
                        <div className='col-xl-10 col-lg-12 maincol'>
                            <div className='row count-row'>
                                <div className='col-3 count-col'>
                                    <div className='content-count' ref={ref}>
                                        <div className='count' >
                                            <span>
                                                {
                                                    startCount && (
                                                        <CountUp
                                                            start={0}
                                                            end={8}
                                                            duration={10}
                                                            delay={1}
                                                            suffix='+'
                                                        />
                                                    )
                                                }
                                            </span>
                                        </div>
                                        <p>Years of experience</p>
                                    </div>
                                </div>
                                <div className='col-3 count-col'>
                                    <div className='content-count' ref={ref}>

                                        <div className='count'>
                                            <span>
                                                {
                                                    startCount && (
                                                        <CountUp
                                                            start={0}
                                                            end={100}
                                                            duration={10}
                                                            suffix='%'
                                                        />
                                                    )
                                                }
                                            </span>
                                        </div>
                                        <p>Job Success Rate</p>
                                    </div>
                                </div>
                                <div className='col-3 count-col'>
                                    <div className='content-count' ref={ref}>

                                        <div className='count'>
                                            <span>
                                                {
                                                    startCount && (
                                                        <CountUp
                                                            start={0}
                                                            end={250}
                                                            duration={10}
                                                            suffix='+'
                                                        />
                                                    )
                                                }
                                            </span>
                                        </div>
                                        <p>Jobs Completed</p>
                                    </div>
                                </div>
                                <div className='col-3 count-col'>
                                    <div className='content-count' ref={ref}>

                                        <div className='count'>
                                            <span>
                                                {
                                                    startCount && (
                                                        <CountUp
                                                            start={0}
                                                            end={300}
                                                            duration={10}
                                                            suffix='+'
                                                        />
                                                    )
                                                }
                                            </span>
                                        </div>
                                        <p>Landing Pages Crafted</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
    </div>
  )
}

export default StorySection